export default __webpack_public_path__ + "img/ce6990e71845a7ae58b0a2e410584244.svg";